import { render } from "./RobotDetail.vue?vue&type=template&id=165f4312"
import script from "./RobotDetail.vue?vue&type=script&lang=js"
export * from "./RobotDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__